export default function (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.defer = true;
    script.src = url;
    document.head.appendChild(script);
  });
}
